module.exports = __webpack_public_path__ + "static/media/cable-car-city-elements-svgrepo-com.1cad038e.svg";